import { CardContent, css } from '@mui/material';
import styled from '@emotion/styled/macro';

export const StyledClaimCardContent = styled(CardContent, {
  shouldForwardProp: (prop) => prop !== 'statusUpdated',
})(
  ({ theme, statusUpdated }) => css`
    align-items: center;
    border: ${statusUpdated ? `2px solid ${theme.palette.main.professional_blue}` : 'none'};
    border-radius: 4px;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    padding: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimCardContentTextContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: ${theme.spacing('SMALL')};
  `
);
